import { render } from "./ag-create-event-severity.vue?vue&type=template&id=17287f1a&scoped=true"
import script from "./ag-create-event-severity.vue?vue&type=script&lang=js"
export * from "./ag-create-event-severity.vue?vue&type=script&lang=js"

import "./ag-create-event-severity.vue?vue&type=style&index=0&id=17287f1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17287f1a"]])

export default __exports__